import React from "react";
import "../../Default.css";
import Saint from "./saintsType";

function SaintsRender(saint: Saint) {
  return (
    <>
      <div className="page-title">{saint.name}</div>
      <div className="boxes-contener">
        <div className="copyright-tekst">https://sdmpolska.pl</div>
        <div className="text-box">
          <img style={{ width: "100%" }} src={saint.img} alt="img" />
          <div className="paragraf">{saint.description}</div>
        </div>
        <div className="text-box">
          <div className="text-box-header">{saint.atribiute.name}</div>
          <div className="paragraf">{saint.atribiute.description}</div>
        </div>
        <div className="text-box">
          <div className="text-box-header">MODLITWA</div>
          <div className="paragraf">{saint.prayer}</div>
        </div>
      </div>
    </>
  );
}

export default SaintsRender;
